import React, { useRef }         from 'react';
import {
  useDispatch,
  useSelector
}                                from "react-redux";
import useClickOutside           from "../../../hooks/useClickOutside";
import { ApplicationState }      from "../../../store";
import { closeWarningException } from "../../../store/layouts/actions";
import { LayoutState }           from "../../../store/layouts/types";
import CloseIconComponent        from "../CloseIconComponent";
import './style.scss';

interface Props {
}

const WarningComponent: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const {warningMessage} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const ref = useRef<HTMLDivElement>(null);
  const onclose = () => dispatch(closeWarningException());

  useClickOutside(ref, onclose);
  return (
    <div className='warning'
         ref={ref}
    >
      <div className='warning__title'>
        <h2>Warning</h2>
        <CloseIconComponent handler={onclose}/>
      </div>

      <div className='warning__content'>
        {warningMessage}
      </div>
    </div>
  );
};

export default WarningComponent;